import { DateTime } from "luxon";

/**
 * Receive string date with this format: yyyy-MM-dd at the beginning e.x: 2023-08-15 or ISO date 2023-01-18T15:02:50.777595
 * returns date like this: 2 Jan
 */
const formatDayShortMonthDate = (stringDate) => {
    try {
        let formattedDate = DateTime.fromISO(stringDate, { zone: 'utc'});
        let format = 'd MMM';
        if(stringDate?.length > 10) {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            formattedDate = formattedDate.setZone(timeZone);
        }

        return formattedDate.toFormat(format); 
    } catch (error) {
        console.error('formatUtcDate', error);
        return 'Invalid date';
    }     
};

/**
 * Receive string date with this format: yyyy-MM-dd at the beginning e.x: 2023-08-15 or ISO date 2023-01-18T15:02:50.777595
 * returns date like this: Jan 2, 2023
 */
const formatShortMonthDate = (stringDate, showDay = false) => {
    try {
        if(stringDate?.length > 10) {
            stringDate = stringDate.slice(0,10);
        }
        const format = showDay ? DateTime.DATE_MED_WITH_WEEKDAY : DateTime.DATE_MED;
        const formattedDate = DateTime.fromFormat(stringDate, 'yyyy-MM-dd').toLocaleString(format);
        return formattedDate;
    } catch (error) {
        console.error('formatShortMonthDate', error);
        return 'Invalid date';
    }    
};

/**
 * Receive UTC string date
 * returns date like this: Jan 2, 2023, 10:34 AM
 */
const formatShortMonthTime = (stringDate) => {
    try {
        let formattedDate = DateTime.fromISO(stringDate, { zone: 'utc'});
        let format = 'DD';
        if(stringDate?.length > 10) {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            formattedDate = formattedDate.setZone(timeZone);
            format = 'ff';
        }
        return formattedDate.toFormat(format);
    } catch (error) {
        console.error('formatShortMonthTime', error);
        return 'Invalid date';
    }    
};

/**
 * Receive UTC string date
 * returns date like this: 01/26/2022 11:05 AM
 */
const formatUtcDate = (stringDate) => {
    try {
        let formattedDate = DateTime.fromISO(stringDate, { zone: 'utc'});
        let format = 'D';
        if(stringDate?.length > 10) {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            formattedDate = formattedDate.setZone(timeZone);
            format = 'f';
        }

        return formattedDate.toFormat(format); 
    } catch (error) {
        console.error('formatUtcDate', error);
        return 'Invalid date';
    }    
};

/**
 * Receive UTC string date
 * returns date like this: 01/26/2022
 */
const formatUtcDateShort = (stringDate) => {
    try {
        let formattedDate = DateTime.fromISO(stringDate, { zone: 'utc'});
        let format = 'D';
        if(stringDate?.length > 10) {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            formattedDate = formattedDate.setZone(timeZone);
        }

        return formattedDate.toFormat(format); 
    } catch (error) {
        console.error('formatUtcDateShort', error);
        return null;
    }    
};

/**
 * returns date like this: 01-26-2022
 */
const formatShortDate = (stringDate) => {
    try {
        let formattedDate = DateTime.fromISO(stringDate, { zone: 'utc'});
        let format = 'D';
        let shortDate = formattedDate.toFormat(format); 

        return shortDate.replaceAll("/", "-");
    } catch (error) {
        console.error('formatUtcDate', error);
        return 'Invalid date';
    }
};

export { formatUtcDate, formatShortMonthDate, formatShortMonthTime, formatDayShortMonthDate, formatShortDate, formatUtcDateShort };
